import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import cropService from '../../services/crop.service';
import Toast from '../../components/Toast/Toast';

const ViewCrops = () => {
  const { isSuperAdmin } = useAuth();
  const [crops, setCrops] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  const fetchCrops = async () => {
    setLoading(true);
    try {
      const cid = isSuperAdmin ? localStorage.getItem('selectedCompanyId') : null;
      const res = await cropService.getCrops(1, 200, search, cid);
      if (res.success) setCrops(res.data?.crops || []);
    } catch {
      setToast({ message: 'Failed to fetch crops', type: 'error' });
    } finally { setLoading(false); }
  };

  useEffect(() => { fetchCrops(); }, [isSuperAdmin, search]);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this crop?')) return;
    try {
      await cropService.deleteCrop(id);
      setToast({ message: 'Crop deleted', type: 'success' });
      fetchCrops();
    } catch (err) {
      setToast({ message: err.response?.data?.message || 'Failed to delete', type: 'error' });
    }
  };

  return (
    <div style={{ padding: 24 }}>
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
      <h4 style={{ marginBottom: 16 }}>Crops</h4>
      <input
        type="text" placeholder="Search crops..."
        value={search} onChange={(e) => setSearch(e.target.value)}
        style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #dee2e6', marginBottom: 16, width: 280 }}
      />
      {loading ? <p>Loading...</p> : crops.length === 0 ? <p>No crops found</p> : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#4a8c2a', color: '#fff' }}>
              <th style={{ padding: 10, textAlign: 'left' }}>Name</th>
              <th style={{ padding: 10, textAlign: 'left' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {crops.map(c => (
              <tr key={c.id} style={{ borderBottom: '1px solid #e9ecef' }}>
                <td style={{ padding: 10 }}>{c.name}</td>
                <td style={{ padding: 10 }}>
                  <button onClick={() => handleDelete(c.id)}
                    style={{ padding: '4px 10px', background: '#fce4ec', color: '#c62828', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ViewCrops;